(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (() => {
    const updateCountdown = (countdown) => {
      const target = new Date(countdown.dataset.countdownTarget).getTime();
      const remaining = Math.max(0, target - Date.now());
      const values = {
        days: Math.floor(remaining / (1000 * 60 * 60 * 24)),
        hours: Math.floor((remaining / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((remaining / (1000 * 60)) % 60),
        seconds: Math.floor((remaining / 1000) % 60),
      };

      Object.entries(values).forEach(([unit, value]) => {
        const element = countdown.querySelector(`[data-${unit}]`);
        if (element) element.textContent = String(value).padStart(2, '0');
      });
    };

    const countdowns = document.querySelectorAll('[data-promotion-countdown]');
    countdowns.forEach(updateCountdown);
    window.setInterval(() => countdowns.forEach(updateCountdown), 1000);
  })();

  } catch(e) { console.error(e); }
})();
})();
